import React from 'react';
import classNames from 'classnames';
import styles from '../assets/deduction-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import { QueryParams } from 'src/types/grid';
import { IDeduction } from 'src/types/deduction';
//import DeductionActionsColumn from './DeductionActionsColumn';
import textFilter from '../../../../../../../components/react-table/filters/text-filter';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';
interface Props {
    data: Paginated<IDeduction>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IDeduction>[] = [
    {
        Header: 'Amount',
        accessor: 'amount',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) => (original.amount ? `${numberWithCommas(original.amount)}$` : ''),
        Filter: textFilter<IDeduction>(),
    },
    {
        Header: 'Deduction Date',
        accessor: 'deductionDate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) =>
            original.deductionDate ? changeToZeroMoment(original.deductionDate, 'MMM DD, YYYY') : '',
        Filter: textFilter<IDeduction>(),
    },

    {
        Header: 'Session Date',
        accessor: 'seanceDate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) =>
            original.seanceDate ? changeToZeroMoment(original.seanceDate, 'MMM DD, YYYY') : '',
        Filter: textFilter<IDeduction>(),
    },
    {
        Header: 'Included in Payroll',
        accessor: 'payrollDeductions',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) =>
            original.payrollDeductions && original.payrollDeductions.length && original.payrollDeductions[0].paymentId
                ? original.payrollDeductions[0].paymentId
                : '',
        Filter: textFilter<IDeduction>(),
    },

    {
        Header: 'Provider',
        accessor: 'provider.id',
        disableSortBy: true,
        disableFilters: true,
        // Filter: dropdownFilter<IDeduction>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
        Filter: textFilter<IDeduction>(),
    },

    {
        Header: 'Student',
        accessor: 'student.id',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDeduction>) => {
            if (!original?.student) return '';

            return (
                <Link
                    to={Router.generate(routes.STUDENT_DETAIL, {
                        id: original?.student?.id,
                        tab: 'student-info',
                    })}
                >
                    {`${original.student?.firstName} ${original.student?.lastName}`}
                </Link>
            );
        },
    },
    /*    {
        Header: 'Actions',
        accessor: 'id',
        Cell: DeductionActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },*/
];

const DeductionsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IDeduction> columns={columns} data={data} getData={getData} />
    </div>
);

export default DeductionsGrid;
